// GSAP VIDEO AND IMAGE LAZYLOAD
if (!Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function() {
    const lazyVideos = document.querySelectorAll(".lazy-video");

    // GSAP ScrollTrigger for each video
    gsap.registerPlugin(ScrollTrigger);
    lazyVideos.forEach(video => {
      ScrollTrigger.create({
        trigger: video,
        start: "top 50%",  // Adjust as needed
        end: "bottom 20%", // Adjust as needed
        onEnter: () => {
          video.muted = true;  // Ensure autoplay compliance
          video.play();
        },
        onEnterBack: () => video.play(),
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      });
    });


    // Lazy loading images
    const lazyImages = document.querySelectorAll(".lazy-image");
    lazyImages.forEach(image => {
      const newSRC = image.getAttribute('srcset'); // Source for the new image
      const newImage = document.createElement("img"); // Create new image element
      
      // Load the image when the ScrollTrigger activates
      const loadImage = () => {
        newImage.onload = () => {
          newImage.onload = null; // Avoid recursion
          image.src = newSRC; // Set the high-res image as the main source

          // Place the low-res version on TOP and then fade it out
          gsap.set(newImage, {
            position: "absolute",
            top: image.offsetTop,
            left: image.offsetLeft,
            width: image.offsetWidth,
            height: image.offsetHeight
          });
          image.parentNode.appendChild(newImage); // Add new image to DOM

          // Fade out the new image after it's loaded
          gsap.to(newImage, {
            opacity: 0,
            onComplete: () => newImage.parentNode.removeChild(newImage) // Remove new image after fade out
          });
          
          // Kill the ScrollTrigger instance after loading the image
          st.kill();
        };

        newImage.src = newSRC; // Trigger image loading
      };

      // Create a ScrollTrigger for lazy loading
      const st = ScrollTrigger.create({
        trigger: image,
        start: "-50% bottom",
        onEnter: loadImage,
        onEnterBack: loadImage // Make sure it works in either direction
      });
    });
  });
}

// hp-slideshow
(function ($) {
	"use strict";

	/*=============================================
		=    		 Swiper Slider			      =
	=============================================*/
	if ($('.hatch-pro-slideshow').length) {
		$('.hatch-pro-slideshow').each(function () {
			var SwiperCarousel = $(this);
			var breakpoints = {
				480: { slidesPerView: SwiperCarousel.data('sm-items') || 1, loop: SwiperCarousel.data('sm-loop') || true, spaceBetween: SwiperCarousel.data('sm-space') || 30 },
				640: { slidesPerView: SwiperCarousel.data('md-items') || 1, loop: SwiperCarousel.data('md-loop') || true, spaceBetween: SwiperCarousel.data('md-space') || 30 },
				991: { slidesPerView: SwiperCarousel.data('lg-items') || 1, loop: SwiperCarousel.data('lg-loop') || true, spaceBetween: SwiperCarousel.data('lg-space') || 30 },
				1199: { slidesPerView: SwiperCarousel.data('xl-items') || 1, loop: SwiperCarousel.data('xl-loop') || true, spaceBetween: SwiperCarousel.data('xl-space') || 30 }
			};

			var swiper = new Swiper(SwiperCarousel[0], {
				slidesPerView: SwiperCarousel.data('items') || 1,
				loop: SwiperCarousel.data('loop') || true,
				// speed: SwiperCarousel.data('speed') || 600,
				effect: SwiperCarousel.data('effect') || 'fade',
				lazy: SwiperCarousel.data('lazy') || true,
				spaceBetween: SwiperCarousel.data('space') || 30,
				navigation: { nextEl: SwiperCarousel.data('next'), prevEl: SwiperCarousel.data('prev') },
				pagination: { el: SwiperCarousel.data('pagination'), clickable: true, },
				scrollbar: { el: SwiperCarousel.data('scrollbar'), hide: false },
				fadeEffect: { crossFade: true },
				autoplay: SwiperCarousel.data('autoplay') || false,
				autoplay: {
					delay: 2000,
				},
				breakpoints: breakpoints
			});
		});
	}
})(jQuery);
